import { Edit, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const EditForeignLanguages = () => {
  return (
    <Edit
      title="Редакция на чужд език"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm>
        <SaveForm />
      </SimpleForm>
    </Edit>
  );
};
export default EditForeignLanguages;
